import { useAnalytics } from '@modernhealth/web-analytics';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import React, { useEffect, useRef } from 'react';
import { EventType } from 'src/shared/services/analytics';
import { makeCelebrationTitleKeyIndex } from '../util/makeCelebrationTitleKeyIndex';
import { DailyPauseCelebration, DailyPauseCelebrationProps } from './DailyPauseCelebration';
import { DailyPauseNewCelebration } from './DailyPauseNewCelebration';

const DPStreaksExperimentKey = 'daily-pause-streaks-experiment-variant';

export const DailyPauseCelebrationContainer: React.FC<DailyPauseCelebrationProps> = props => {
    const analytics = useAnalytics();
    const ldClient = useLDClient();
    const dailyPauseStreaksExperimentVariant = ldClient?.variation(
        DPStreaksExperimentKey,
        'ineligible',
    ); // could be 'control', 'treatment', 'ineligible', undefined
    const isTrackEventSent = useRef(false);
    const { startDailyPauseStreaksExperimentWeb } = useFlags();

    useEffect(() => {
        if (
            isTrackEventSent.current === false &&
            startDailyPauseStreaksExperimentWeb &&
            ['control', 'treatment'].includes(dailyPauseStreaksExperimentVariant)
        ) {
            analytics.track('variation assigned', EventType.EXPERIMENT, {
                experiment_id: 'daily-pause-streaks',
                experiment_variant_assigned: dailyPauseStreaksExperimentVariant,
            });
            isTrackEventSent.current = true;
        }
    }, [dailyPauseStreaksExperimentVariant, analytics, startDailyPauseStreaksExperimentWeb]);

    const celebrationTitleKeyIndex = makeCelebrationTitleKeyIndex();

    if (startDailyPauseStreaksExperimentWeb && dailyPauseStreaksExperimentVariant === 'treatment') {
        return (
            <DailyPauseNewCelebration
                {...props}
                celebrationTitleKeyIndex={celebrationTitleKeyIndex}
            />
        );
    }

    return <DailyPauseCelebration {...props} celebrationTitleKeyIndex={celebrationTitleKeyIndex} />;
};
